const r=(r,c={},e=!1)=>{const t="scheme"===r?"card":r;return"card"===t&&e?c.storedCard||{}:c[t]||{}};export{r as getComponentConfiguration};
